import React, { useState } from 'react';
import config from '../../config.json';

const chatbotTree = {
  root: {
    message: "Hi! What would you like to do?",
    options: [
      { label: "Say Hello", next: "hello" },
      { label: "Get Info", next: "info" }
    ]
  },
  hello: {
    message: "Hello there! 👋",
    options: []
  },
  info: {
    message: "Choose an info topic:",
    options: [
      { label: "Organizations", next: "orgOptions" },
      { label: "More Info", next: "moreInfo" }
    ]
  },
  orgOptions: {
    message: "Organization options:",
    options: [
      { label: "How many organizations do I have?", next: "getOrganizations" },
      { label: "List my organization names", next: "listOrganizations" }
    ]
  },
  moreInfo: {
    message: "What more would you like to know?",
    options: [
      { label: "Show my active projects", next: "getActiveProjects" },
      { label: "Get user details", next: "getUserDetails" }
    ]
  },
  getOrganizations: {
    message: "Checking your organizations...",
    isApi: true,
    apiEndpoint: `${config.SERVER_URL}fincorp_getFileTypes`
  },
  listOrganizations: {
    message: "Fetching organization names...",
    isApi: true,
    apiEndpoint: ""
  },
  getActiveProjects: {
    message: "Loading active projects...",
    isApi: true,
    apiEndpoint: ""
  },
  getUserDetails: {
    message: "Getting user details...",
    isApi: true,
    apiEndpoint: ""
  }
};

const Chatbot = () => {
  const [messages, setMessages] = useState([
    { text: chatbotTree.root.message, sender: 'bot' }
  ]);
  const [currentNode, setCurrentNode] = useState(chatbotTree.root);
  const [history, setHistory] = useState(['root']);
  const [loading, setLoading] = useState(false);

  const handleOptionClick = async (option) => {
    const nextKey = option.next;
    const next = chatbotTree[nextKey];
    setMessages((prev) => [...prev, { text: next.message, sender: 'bot' }]);
    setCurrentNode(next);
    setHistory((prev) => [...prev, nextKey]);

    if (next.isApi && next.apiEndpoint) {
      setLoading(true);
      try {
        const res = await fetch(next.apiEndpoint, {
          headers: { 'Accept': 'application/json' }
        } );
        // const text = await res.text();
        const data = await res.json();
        setMessages((prev) => [
          ...prev,
          { text: JSON.stringify(data, null, 2), sender: 'bot' }
        ]);
      } catch (err) {
        setMessages((prev) => [
          ...prev,
          { text: `Failed to fetch data. Error: ${err.message}`, sender: 'bot' }
        ]);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleBack = () => {
    if (history.length > 1) {
      const newHistory = [...history];
      newHistory.pop(); // remove current step
      const prevKey = newHistory[newHistory.length - 1];
      const prevNode = chatbotTree[prevKey];

      // Rebuild messages from history
      const rebuiltMessages = newHistory.map(key => ({ text: chatbotTree[key].message, sender: 'bot' }));

      setMessages(rebuiltMessages);
      setCurrentNode(prevNode);
      setHistory(newHistory);
    }
  };

  return (
    <div style={{ position: 'fixed', bottom: '20px', right: '20px', width: '400px', height: '600px', border: '1px solid #003B5C', fontFamily: 'Arial, sans-serif', display: 'flex', flexDirection: 'column', backgroundColor: '#002F45', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)' }}>
      <div style={{ backgroundColor: '#003B5C', color: 'white', padding: '16px', fontWeight: 'bold', fontSize: '1.2em', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
        Chatbot <span style={{ fontSize: '0.8em', fontWeight: 'normal' }}>• Online Now</span>
      </div>
      <div style={{ flex: 1, padding: '16px', backgroundColor: '#f9fbff', overflowY: 'auto' }}>
        {messages.map((msg, index) => (
          <div key={index} style={{ marginBottom: '12px' }}>
            <div style={{ backgroundColor: '#e6f0ff', padding: '12px', borderRadius: '20px', display: 'inline-block', maxWidth: '80%' }}>
              {msg.text}
            </div>
          </div>
        ))}
        {loading && <div>Loading...</div>}
      </div>
      <div style={{ padding: '16px', backgroundColor: '#E5EEF5', borderTop: '1px solid #cce0ff', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
        {currentNode.options?.map((option, i) => (
          <button
            key={i}
            onClick={() => handleOptionClick(option)}
            style={{
              margin: '5px 5px 0 0',
              padding: '10px 20px',
              borderRadius: '20px',
              border: '2px solid #005983',
              backgroundColor: 'white',
              color: '#005983',
              cursor: 'pointer',
              fontSize: '1em'
            }}
          >
            {option.label}
          </button>
        ))}
        {history.length > 1 && (
          <button
            onClick={handleBack}
            style={{
              margin: '10px 5px 0 0',
              padding: '8px 16px',
              borderRadius: '20px',
              border: '2px solid #999',
              backgroundColor: '#fff',
              color: '#333',
              cursor: 'pointer',
              fontSize: '0.9em'
            }}
          >
            ⬅ Back
          </button>
        )}
      </div>
    </div>
  );
};

export default Chatbot;
